var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.travelService !== null
        ? [
            _c("OrderDetailsForOrderItem", {
              attrs: { data: _vm.travelService }
            }),
            _c("OrderItemParameters", {
              attrs: {
                type: _vm.travelService.orderItem.type,
                "order-item": _vm.travelService.orderItem
              }
            }),
            _vm.travelService.selected_offer !== null
              ? [
                  _c(
                    "fieldset",
                    {
                      staticClass: "custom-fieldset",
                      class: {
                        "fieldset-warning":
                          _vm.travelService.orderItem.status ===
                          _vm.itemsStatus.STATUS_CLIENT_REQUEST_BOOKING_CANCEL,
                        "fieldset-error":
                          _vm.travelService.orderItem.status ===
                          _vm.itemsStatus.STATUS_BOOKING_CANCELLED
                      }
                    },
                    [
                      _c(
                        "legend",
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("travelService.chooseOfferForm.service")
                              ) +
                              " - " +
                              _vm._s(
                                _vm.$t(
                                  "travelService.types." +
                                    _vm.travelService.orderItem.type
                                )
                              ) +
                              " "
                          ),
                          _vm.travelService.orderItem.status ===
                          _vm.itemsStatus.STATUS_CLIENT_REQUEST_BOOKING_CANCEL
                            ? [
                                _vm._v(
                                  " (" +
                                    _vm._s(
                                      _vm.$t(
                                        "travelService.singleServiceOrderStatus.requestBookingCancel"
                                      )
                                    ) +
                                    ") "
                                )
                              ]
                            : _vm._e(),
                          _vm.travelService.orderItem.status ===
                          _vm.itemsStatus.STATUS_BOOKING_CANCELLED
                            ? [
                                _vm._v(
                                  " (" +
                                    _vm._s(
                                      _vm.$t(
                                        "travelService.singleServiceOrderStatus.bookingCanceled"
                                      )
                                    ) +
                                    ") "
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      ),
                      _c(
                        "v-row",
                        [
                          _vm.travelService.selected_offer.html != null &&
                          _vm.travelService.selected_offer.html.length !== 0
                            ? _c(
                                "v-col",
                                { attrs: { md: "10" } },
                                [
                                  _c("w-y-s-i-w-y-g-html-element", {
                                    attrs: {
                                      html:
                                        _vm.travelService.selected_offer.html
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.travelService.orderItem.type === "hotel" &&
                          (_vm.travelService.selected_offer.html == null ||
                            _vm.travelService.selected_offer.html.length === 0)
                            ? _c(
                                "v-col",
                                { attrs: { md: "10", cols: "12" } },
                                [
                                  _c("hotel-response-presentation", {
                                    attrs: {
                                      offer: _vm.travelService.selected_offer
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.travelService.orderItem.type === "car" &&
                          (_vm.travelService.selected_offer.html == null ||
                            _vm.travelService.selected_offer.html.length === 0)
                            ? _c(
                                "v-col",
                                { attrs: { md: "10", cols: "12" } },
                                [
                                  _c("car-response-presentation", {
                                    attrs: {
                                      offer: _vm.travelService.selected_offer
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.travelService.orderItem.type === "flight" &&
                          (_vm.travelService.selected_offer.html == null ||
                            _vm.travelService.selected_offer.html.length === 0)
                            ? _c(
                                "v-col",
                                { attrs: { md: "10", cols: "12" } },
                                [
                                  _c("flight-response-presentation", {
                                    attrs: {
                                      offer: _vm.travelService.selected_offer
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.travelService.orderItem.type === "rail" &&
                          (_vm.travelService.selected_offer.html == null ||
                            _vm.travelService.selected_offer.html.length === 0)
                            ? _c(
                                "v-col",
                                { attrs: { md: "10", cols: "12" } },
                                [
                                  _c("rail-response-presentation", {
                                    attrs: {
                                      offer: _vm.travelService.selected_offer
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-col",
                            {
                              staticClass: "pl-3",
                              attrs: { md: "2", cols: "12" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("global.amount"),
                                  value:
                                    _vm.travelService.selected_offer.price +
                                    " " +
                                    _vm.travelService.selected_offer.currency,
                                  outlined: "",
                                  readonly: ""
                                }
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "text-center my-3",
                                  staticStyle: { width: "100%" }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticStyle: { "font-size": "100px" },
                                      attrs: { color: "primary" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.bookingIconType(
                                            _vm.travelService.orderItem.type
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _c(
              "v-alert",
              {
                attrs: {
                  value:
                    _vm.travelService.status === _vm.serviceStatus.STATUS_SEND,
                  outlined: "",
                  color: "error darken-4"
                }
              },
              [
                _vm._v(
                  " Zamówienie oczekuje na wybór z dostępnych ofert. Kliknij "
                ),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.$router.push(
                          "/travel-service/choose-offer/" + _vm.travelService.id
                        )
                      }
                    }
                  },
                  [_vm._v("tutaj")]
                ),
                _vm._v(" aby przejść do formularza wyboru. ")
              ]
            ),
            _vm.notSelectedResponses.length > 0
              ? [
                  _c("h3", [_vm._v("Lista ofert które nie zostały wybrane")]),
                  _vm._l(_vm.notSelectedResponses, function(response) {
                    return _c(
                      "span",
                      { key: response.id },
                      [
                        _c(
                          "offer-archive-dialog",
                          {
                            attrs: {
                              type: _vm.travelService.orderItem.type,
                              id: response.id,
                              "is-admin": false
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(response.last_edit_at) +
                                " " +
                                _vm._s(response.last_edit_by_name) +
                                " "
                            ),
                            _c(
                              "v-btn",
                              { attrs: { icon: "" } },
                              [_c("v-icon", [_vm._v("remove_red_eye")])],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ]
              : _vm._e(),
            _vm.travelService.messages
              ? _c("message-list", {
                  staticClass: "mb-3",
                  attrs: {
                    "travel-service-order-id": _vm.travelService.id,
                    "travel-service-order-item-id":
                      _vm.travelService.orderItem.id,
                    "start-messages": _vm.travelService.messages
                  }
                })
              : _vm._e(),
            _vm.travelService.selected_offer !== null &&
            _vm.travelService.selected_offer.history.length > 0
              ? [
                  _c("h3", [
                    _vm._v(_vm._s(_vm.$t("travelService.outdatedOffers")) + ":")
                  ]),
                  _vm._l(_vm.travelService.selected_offer.history, function(
                    historyItem
                  ) {
                    return _c(
                      "span",
                      { key: historyItem.id },
                      [
                        _c(
                          "offer-archive-dialog",
                          {
                            attrs: {
                              type: _vm.travelService.orderItem.type,
                              id: historyItem.id,
                              "is-admin": false
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(historyItem.last_edit_at) +
                                " " +
                                _vm._s(historyItem.last_edit_by_name) +
                                " "
                            ),
                            _c(
                              "v-btn",
                              { attrs: { icon: "" } },
                              [_c("v-icon", [_vm._v("remove_red_eye")])],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ]
              : _vm._e()
          ]
        : _vm._e(),
      _c(
        "v-row",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { color: "blue darken-1", text: "" },
              nativeOn: {
                click: function($event) {
                  return _vm.cancel()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("global.cancel")))]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }